// import ResponsiveObserver from 'responsive-observer'
import './searchbar.less'
const TYPE = ['text', '', 'date', 'daterange', 'select', 'cascader']
const DEAD_TYPE = ['text', '', 'date', 'daterange']
const SELECT_DEFAULT_PROPS = {
    value: 'id',
    label: 'label'
}
const CASCADER_DEFAULT_PROPS = {value: 'id', label: 'label', children: 'children'}
const DEFAULT_DATE_PICKER = 'date'
const DATE_PICKER_FORMAT = {
    date: {
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd'
    },
    month: {
        format: 'yyyy-MM',
        valueFormat: 'yyy-MM'
    },
    daterange: {
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd'
    }
}

function toCamelCase (str, split = '') {
    let strs = split ? str.split(split) : [str]
    if (strs && strs.length) {
        return strs.map(str => str.substring(0, 1).toUpperCase() + str.substring(1)).join('')
    }
    return str
}

/* istanbul ignore next */
function getDays (start, num) {
    let days = 0
    for (let i = 0; i < num; ++i) {
      days += new Date(start.getFullYear(), start.getMonth() - i, 0).getDate()
    }
    return days
}

export default {
    props: {
        search: { // 当只有一个单行文本输入框时是否展现为搜索框
            type: Boolean,
            defalut: true
          },
          theme: {
            type: String, // 可选值 ant
            defalut: ''
          },
          value: {
            type: Object,
            /* istanbul ignore next */
            default () {
              /* istanbul ignore next */
              return {}
            }
          },
          items: {
            type: Array,
            defalut: () => {
              /* istanbul ignore next */
              return []
            }
          },
          labelWidth: {
            type: String,
            default: ''
          },
          autoReset: {
            type: Boolean,
            default: true
          },
          showButton: {
            type: Boolean,
            default: true
          },
          gutter: {
            type: Number,
            default: 24
          } 
    },
    
    
    computed: {
        shouldCollapse () {
          return this.items.length > 3
        },
        shouldReset () {
          return !this.isSingle
        },
        /**
         * @description 是否为预定义搜索框
         */
        isSearchInput () {
          return this.search && this.isSingle && (!this.items[0].type || this.items[0].type === 'text')
        },
        /**
         * @description 是否显示表单
         */
        shouldSearchForm () {
          return this.items && this.items.length > 0
        },
        isSingle () {
          if (!this.items) return 0 
          return this.items.length === 1
        },
        itemSpan () {
          if (!this.items) return 0 
          // 一行三个
          if (this.items.length >= 3) {
            return 8
          } else {
            // return this.isSingle ? 24 : 12
            return this.screens.xl && this.isSingle ? 24 : 12
          }
        },
        span () {
          if (!this.items) return 0 
          if (this.items.length > 3 && !this.collapse && this.theme === 'ant') return 24
          else if (this.items.length > 3 && this.theme === 'ant') return 8
          else if (this.items.length > 3) return 6
          else {
            return 24 - this.items.length * 6
          }
        }
      },
      watch: {
        value: {
          immediate: true,
          deep: true,
          handler (val) {
            if (val) this.model = val
          }
        },
        model: {
          deep: true,
          handler () {
            if (this.value) this.emitInput(this.model)
          }
        },
        items: {
          deep: true,
          handler () {
            this.__init()
          }
        }
      },
      data () {
        return {
          collapse: true,
          screens: {},
          height: 0,
          model: {},
          globalPickerOptions: {
            shortcuts: [{
              text: '最近一周',
              onClick (picker) {
                /* istanbul ignore next */
                {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                  picker.$emit('pick', [start, end])
                }
              }
            }, {
              text: '最近一个月',
              onClick (picker) {
                /* istanbul ignore next */
                {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * getDays(start, 1))
                  picker.$emit('pick', [start, end])
                }
              }
            }, {
              text: '最近三个月',
              onClick (picker) {
                /* istanbul ignore next */
                {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * getDays(start, 3))
                  picker.$emit('pick', [start, end])
                }
              }
            }]
          },
          remoteData: {} // 远程数据 存储下拉框级联框等组件数据
        }
      },
      render (h) {
        let {labelWidth, gutter, showButton, span, isSearchInput, items} = this
        return (
            this.items.length > 0 ?
            <div ref="content" class="v-searchbar">
                <el-form nativeOnSubmit={this.onSubmit}  inline label-width={labelWidth} >
                    <el-row gutter={24}>
                        <el-col md={24} lg={showButton ?  24 - span : 24}>
                            <el-row gutter={gutter}>
                            {
                              isSearchInput ? this.__renderSearchInput(items[0]) : this.__renderItems(h, items)
                            }
                            </el-row>
                        </el-col>
                        {
                          showButton ? this.__renderButtons() : ''
                        }
                    </el-row>
                </el-form>
            </div> : <span style="font-size:0;"></span>
        )
    },
      methods: {
        onSubmit (e) {
            e.preventDefault()
        },
        __renderItem (h, item) {
            let {model} = this
            let prop = item.prop
            let props = item.props ? item.props : {} // 别名
            let placeholder = item.placeholder
            let options = item.options ? item.options : {}
            let type = item.type ? toCamelCase(item.type, '-') : 'Input'
            return this[`__render${type}`]({
                model,
                prop,
                placeholder,
                options,
                props
            }, item, h)
        },
        __renderInput ({model, prop, placeholder, options}) {
            return (
                <el-input value={model[prop]}
                    onInput={e => this.onInput(e, prop)}
                    data-tag="text"
                    placeholder={placeholder}
                    clearable
                    {...options}
                ></el-input>
            )
        },
        __renderSelect ({model, prop, placeholder, options, props}, item) {
            let data = this.remoteData[prop] ? this.remoteData[prop] : []
            let $props = Object.assign(SELECT_DEFAULT_PROPS, props)
            return (
                <el-select  value={model[prop]}
                    onInput={e => this.onInput(e, prop)}
                    placeholder={placeholder}
                    clearable
                    data-tag="select"
                    collapse-tags
                    {...options}>
                    {
                        data.map(it => {
                            return (
                                <el-option key={it[$props.value]}
                                    value={it[$props.value]}
                                    label={it[$props.label]}>
                                    {item.render ? item.render(h, it) : it[$props.label]}
                                </el-option>
                            )
                        })
                    }
                </el-select>
            )
        },
        __renderCascader ({model, prop, placeholder, options, props}) {
            let data = this.remoteData[prop] ? this.remoteData[prop] : []
            let $props = Object.assign(CASCADER_DEFAULT_PROPS, props)
            return (
                <el-cascader style="width:100%;"
                    value={model[prop]}
                    onInput={e => this.onInput(e, prop)}
                    options={data}
                    props={$props}
                    placeholder={placeholder}
                    clearable
                    {...options}
                    data-tag="cascader"
                />
            )
        },
        __renderDatePicker ({model, prop, placeholder, options = {}}) {
            let type = options.attrs ? options.attrs.type : DEFAULT_DATE_PICKER
            let format = DATE_PICKER_FORMAT[type].format
            let valueFormat = DATE_PICKER_FORMAT[type].valueFormat
            return (
                <el-date-picker
                    clearable
                    value={model[prop]}
                    onInput={e => this.onInput(e, prop)}
                    type={type}
                    placeholder={placeholder}
                    data-tag={type}
                    unlink-panels
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format={format}
                    value-format={valueFormat}
                    picker-options={type.indexOf('range') !== -1 ? this.globalPickerOptions: {}}
                    {...options}>
                </el-date-picker>
            )
        },
        __renderItems (h, items) {
            let {itemSpan, collapse} = this
            return (
                items.map((item, index) => {
                    return (
                        <el-col key={item.label} sm={24} md={item.span ? item.span : itemSpan}
                            class={!(!collapse || (collapse && index <= 2)) ? 'v-searchbar-col hidden' : 'v-searchbar-col'}>
                            <el-form-item ref="items" style={{width:'100%'}} label={item.label}>
                                {this.__renderItem(h, item)}
                            </el-form-item>
                        </el-col>
                    )
                })
            )
        },
        __renderSearchInput (item) {
            return (
              <el-form-item ref="items" style={{width:'100%'}} label=" ">
                <el-input
                    nativeOnKeydown={this.onSearch}
                    placeholder={item.placeholder}
                    value={this.model[item.prop]}
                    onInput={e => this.onInput(e, item.prop)}>
                    <i onClick={this.onSearch} slot="suffix" class="el-input__icon el-icon-search search-btn"></i>
                </el-input>
              </el-form-item>
            )
        },
        __renderButtons () {
            let {isSearchInput, shouldReset, shouldCollapse, onSearch, reset, trigger, span, collapse} = this
            return (
                <el-col md={24}  lg={span} >
                    <el-form-item  class={!collapse ? 'btns hidden-md-and-down is-expanded' : 'btns hidden-md-and-down'}>
                        {
                            !isSearchInput ? <el-button type="primary" onClick={onSearch} data-el="search">查询</el-button> : ''
                        }
                        {
                            shouldReset ? <el-button onClick={reset} data-el="reset">重置</el-button> : ''
                        }
                        {
                            shouldCollapse ? <el-button type="text" onClick={trigger} data-el="collapse">{collapse ? '展开' : '收起'}
                            {!collapse ?  <i class="el-icon-arrow-up"></i> : <i class="el-icon-arrow-down"></i>}
                            </el-button> : ''
                        }
                    </el-form-item>
                </el-col>
            )
        },
        emitInput (value = {}) {
          this.$emit('input', value)
        },
        onInput (e, prop) {
          if (typeof this.model[prop] !== 'undefined') this.model[prop] = e
          else this.$set(this.model, prop, e)
        },
        onSearch (e) {
          if (e.key === 'Enter' || e.type === 'click') this.$emit('search')
        },
        __init () {
          this.__initHeight()
          this.__initRemoteData()
        },
        __initHeight () {
          this.$nextTick(() => {
            /* istanbul ignore else */
            if (this.$refs.content) {
              this.height = this.$refs.content.offsetHeight
              this.$emit('trigger')
            }
          })
        },
        trigger () {
          this.collapse = !this.collapse
          this.__initHeight()
        },
        /**
         * @description 重置表单
         */
        reset () {
          // TODO 重置操作放在父组件做比较好，这里暂时这么做了
          if (this.autoReset) {
            Object.keys(this.model).forEach(k => {
              if (Array.isArray(this.model[k])) this.model[k] = []
              else this.model[k] = ''
            })
          } else {
            this.$emit('reset')
          }
        },
        __getRemoteData (api, prop, params = {}) {
          if (!prop) {
            throw new Error(`form item prop cannot be empty.`)
          }
          if (!api) {
            // TODO 以后可能会新增类型
            throw new Error(`When a form item type is not a text, date, daterange, you must provide a remote API：${prop}.`)
          }
          /* istanbul ignore next */
          this.$api(api, params).then(res => {
            this.$set(this.remoteData, prop, res)
          }).catch(err => {
            this.$tips(err, 'error')
          })
        },
        __initRemoteData () {
          if (!this.items) return
          let seedItems = this.items.filter(item => {
            return DEAD_TYPE.indexOf(item.type) === -1 && TYPE.indexOf(item.type) !== -1
          })
          seedItems.forEach(seed => {
            // data：用户自己传入不需要再次请求后台
            if (this.remoteData[seed.prop] && this.remoteData[seed.prop].length > 0 && !seed.data) return 
            if (!seed.data) {
              if (seed.prop) this.$set(this.remoteData, seed.prop, []) // 标准的远程数据应该都是数组
              this.__getRemoteData(seed.api, seed.prop, seed.params ? seed.params : {})
            } else {
              if (!seed.prop) {
                throw new Error(`form item prop cannot be empty.`)
              }
              this.$set(this.remoteData, seed.prop, seed.data)
            }
          })
        },
        __onChange (e, item) {
          if (item && item.on) {
            if (typeof item.on.change === 'function') {
              item.on.change(e)
            }
          }
        }
      },
      mounted () {
        this.__init()
        const ResponsiveObserver = require('responsive-observer').default
        this.observer = new ResponsiveObserver()
        this.observer.subscribe((screens) => {
          this.screens = screens
        })
      },
      created () {
        
      },
      destroyed () {
        if (this.observer) this.observer.unsubscribe()
      }
}


// WEBPACK FOOTER //
// ./src/components/framework/data-grid/searchbar.js